module.exports = "<div class=\"row border-bottom\">\n\t<nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\">\n\t\t<div class=\"navbar-header\">\n\t\t\t<span minimaliza-sidebar logged-in=\"selfStudyTopNavCtrl.loggedIn\"></span>\n\t\t</div>\n\t\t<ul class=\"nav navbar-top-links navbar-right\">\n\t\t\t<li role=\"menuitem\">\n\t\t\t\t<a ui-sref=\"logout\">\n\t\t\t\t\t<i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i>\n\t\t\t\t\tLog out\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</nav>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selfStudy/topNav/template.html
// module id = 1387
// module chunks = 0